<template>
    <BaseDialog
        v-model="dialogOpen"
        width="600"
        :title="$t('message.selectFamilyMember')"
        titleClass="tw-text-xl tw-font-bold tw-text-white"
        headerClass="tw-bg-black"
        :showCloseButton="true"
        :onClose="onClose"
    >
        <div class="tw-py-4">
            <p class="tw-text-sm tw-font-bold text--secondary">
                {{ $t('message.selectFromFamilyMember') }}
            </p>

            <div class="tw-flex tw-flex-col tw-gap-4">
                <div v-for="subAccount in subAccounts" :key="subAccount.id">
                    <div
                        class="tw-flex tw-items-center tw-justify-between tw-gap-2"
                    >
                        <div class="tw-flex tw-items-center tw-gap-4">
                            <v-avatar size="40" class="tw-bg-gray-300">
                                <span> {{ getInitials(subAccount) }}</span>
                            </v-avatar>
                            <div class="tw-flex tw-flex-col">
                                <span class="tw-text-sm tw-font-bold">
                                    {{ subAccount.fullName }}
                                </span>
                                <span class="tw-text-xs text--secondary">
                                    {{ getRelationship(subAccount, user) }}
                                </span>
                            </div>
                        </div>
                        <v-btn
                            class="primary"
                            @click="onSelect(subAccount)"
                            :disabled="checkIfSelected(subAccount)"
                        >
                            Select
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </BaseDialog>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { AUTHENTICATION_MODULE_NAME } from '@/store/moduleNames'
import { useStore } from '@/util/vuex'
import { type AccountDetail } from '../api/getSubAccountsByUserApi'
import BaseDialog from '@/components/base/dialog/BaseDialog.vue'
import {
    getRelationship,
    getInitials,
} from '@/modules/subAccounts/utils/subAccount'

const props = defineProps<{
    subAccounts: AccountDetail[]
    selectedSubAccounts: AccountDetail[]
    isOpen: boolean
}>()

const emit = defineEmits(['onClose', 'onSelect'])

const dialogOpen = ref(props.isOpen)
watch(
    () => props.isOpen,
    (newValue) => {
        dialogOpen.value = newValue
    }
)
watch(dialogOpen, (newValue) => {
    if (!newValue && props.isOpen) {
        emit('onClose')
    }
})

const onClose = () => {
    emit('onClose')
}

const checkIfSelected = (subAccount: AccountDetail): boolean => {
    const account = props.selectedSubAccounts?.find(
        (s: AccountDetail) => s.id === subAccount.id
    )

    return Boolean(account)
}

const store = useStore()
const user = computed(
    () => store.getters[`${AUTHENTICATION_MODULE_NAME}/getUser`]
)

const onSelect = (subAccount: AccountDetail) => {
    emit('onSelect', subAccount)
    onClose()
}
</script>
